(function () {
  function initSwatchScroll(scrollArea) {
    const wrapper = scrollArea.closest('.product-card__swatch-list');
    let isDown = false;
    let startX, scrollLeft;

    // --- Cek overflow & update gradient hint ---
    function checkOverflow() {
      if (!wrapper) return;
      const hasOverflow = scrollArea.scrollWidth > scrollArea.clientWidth;
      wrapper.classList.toggle('has-overflow', hasOverflow);

      const atEnd = scrollArea.scrollLeft + scrollArea.clientWidth >= scrollArea.scrollWidth - 2;
      wrapper.classList.toggle('scrolled-end', atEnd);
    }

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    scrollArea.addEventListener('scroll', checkOverflow);

    // --- Drag-to-scroll (desktop mouse) ---
    scrollArea.addEventListener('mousedown', (e) => {
      isDown = true;
      scrollArea.classList.add('is-dragging');
      startX = e.pageX - scrollArea.offsetLeft;
      scrollLeft = scrollArea.scrollLeft;
      e.preventDefault();
    });

    document.addEventListener('mouseup', () => {
      isDown = false;
      scrollArea.classList.remove('is-dragging');
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const x = e.pageX - scrollArea.offsetLeft;
      const walk = (x - startX) * 1.2; // kecepatan drag
      scrollArea.scrollLeft = scrollLeft - walk;
    });
  }

  function init() {
    document.querySelectorAll('.swatch-scroll-area').forEach(initSwatchScroll);
  }

  // Jalankan sekarang + observe DOM baru (misal: search results load dinamis)
  init();

  const observer = new MutationObserver(() => {
    document.querySelectorAll('.swatch-scroll-area:not([data-scroll-init])').forEach((el) => {
      el.setAttribute('data-scroll-init', '1');
      initSwatchScroll(el);
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();